import { RPGTypes } from '@ps/poker-games-tile-mappers';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Url from 'url-parse';

import useRequest from '@swf/core/hooks/useRequest';
import { select } from '@swf/core/store';
import { generateGameUrl, useGameUrlPayload } from '@swf/poker';

import ENDPOINTS from '../constants/endpoints';

export enum EncodedWebEndpointType {
  TABLE_STATIC_DATA = 'HOME_RING_TABLE',
  TOURNAMENT_STATIC_DATA = 'HOME_TOURNAMENT_STRUCTURE'
}

export interface Props {
  type: string;
  serverAddress: string;
  serverObjectName: string;
  hasVideoSupport?: boolean;
}

export const getType = (type: Props['type']) =>
  type === RPGTypes.CASH_GAME || type === RPGTypes.SAG
    ? EncodedWebEndpointType.TABLE_STATIC_DATA
    : EncodedWebEndpointType.TOURNAMENT_STATIC_DATA;

const useHGGameUrl = ({ type, serverAddress, serverObjectName, hasVideoSupport }: Props) => {
  const [url, setUrl] = useState<string>('');
  const request = useRequest();
  const { resolver, ...payload } = useGameUrlPayload();
  const isEmbedded = useSelector(select.device.isEmbedded);

  useEffect(() => {
    if (!resolver) {
      return;
    }

    if (isEmbedded) {
      setUrl(new Url(resolver).toString());
    } else {
      request({
        service: ENDPOINTS.encodedWebEndpoint,
        body: { serverAddress, serverObjectName, type: getType(type) },
        http: true,
        method: 'GET'
      })
        .pipe(catchError((err) => of(err)))
        .subscribe(({ body }) => {
          if (body) {
            const linkConfig = {
              ...payload,
              gametype: type.toLowerCase(),
              hasvideosupport: hasVideoSupport,
              endpoint: body.encodedWebEndpoint
            };

            setUrl(generateGameUrl(linkConfig, resolver));
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolver]);

  return url;
};

export default useHGGameUrl;
